import SpecProcessor, { type Spec, type Data } from './specProcessor';

export default class HXKLineSpecProcessor extends SpecProcessor {
  static preprocessing(data: Data, spec: Spec): boolean {
    return (
      HXKLineSpecProcessor.isEncodingValid(data, spec) &&
      (HXKLineSpecProcessor.isDataValid(data, spec) as boolean)
    );
  }
}
